import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '../Typography';
import { PasswordCriterias } from './password-criteria.types';
import { PasswordValidator } from './password-validator.component';
export var PasswordValidation = function PasswordValidation(_ref) {
  var confirmNewPassword = _ref.confirmNewPassword,
      newPassword = _ref.newPassword,
      title = _ref.title;
  return (
    /*#__PURE__*/
    React.createElement("div", null, title ?
    /*#__PURE__*/
    React.createElement("div", null, title) :
    /*#__PURE__*/
    React.createElement(Typography, {
      paragraph: true
    },
    /*#__PURE__*/
    React.createElement(FormattedMessage, {
      id: "password.validation.prompt",
      defaultMessage: "Please enter your new password. Make sure it meets the minimum requirements listed below."
    })), PasswordCriterias.map(function (passwordCriteria) {
      return passwordCriteria.isForConfirm ?
      /*#__PURE__*/
      React.createElement(PasswordValidator, {
        key: passwordCriteria.key,
        passwordCriteria: passwordCriteria,
        value: confirmNewPassword,
        values: {
          newPassword: newPassword
        }
      }) :
      /*#__PURE__*/
      React.createElement(PasswordValidator, {
        key: passwordCriteria.key,
        passwordCriteria: passwordCriteria,
        value: newPassword
      });
    }))
  );
};